// extracted by mini-css-extract-plugin
export var indeterminate = "_1p-6";
export var md = "_1p-5";
export var semantic = "_1p-7";
export var sm = "_1p-4";
export var text = "_1p-8";
export var toggleControl = "_1p-0";
export var toggleInput = "_1p-1";
export var toggleSwitch = "_1p-2";
export var xs = "_1p-3";